import { extractHtmlError, fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { ChangePasswordFormViewModel } from "../types";

export default function ChangePasswordFormApp(props: ChangePasswordFormViewModel) {
  const [oldPassword, setOldPassword] = useState(props.values.oldPassword);
  const [newPassword, setNewPassword] = useState(props.values.newPassword);
  const [confirmPassword, setConfirmPassword] = useState(props.values.confirmPassword);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("OldPassword", oldPassword);
      formData.append("NewPassword", newPassword);
      formData.append("ConfirmPassword", confirmPassword);

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const html = await response.text();
      if (!response.ok) {
        throw new Error(html);
      }

      const validationMessage = extractHtmlError(html);
      if (validationMessage) {
        setErrorMessage(validationMessage);
        return;
      }

      window.location.reload();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Ulozeni se nepodarilo.";
      setErrorMessage(message.includes("<") ? extractHtmlError(message) || message : message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app change-password-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="base-form">
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label htmlFor="change-password-old">{props.labels.oldPassword}</label>
              <input
                id="change-password-old"
                className="form-control"
                type="password"
                value={oldPassword}
                disabled={isSubmitting}
                onChange={(event) => {
                  setOldPassword(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="change-password-new">{props.labels.newPassword}</label>
              <input
                id="change-password-new"
                className="form-control"
                type="password"
                value={newPassword}
                disabled={isSubmitting}
                onChange={(event) => {
                  setNewPassword(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="change-password-confirm">{props.labels.confirmPassword}</label>
              <input
                id="change-password-confirm"
                className="form-control"
                type="password"
                value={confirmPassword}
                disabled={isSubmitting}
                onChange={(event) => {
                  setConfirmPassword(event.currentTarget.value);
                  setErrorMessage(null);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="panel-footer">
        <button
          type="button"
          className="btn btn-success btn-sm"
          disabled={isSubmitting}
          onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
        >
          <i className="fa fa-save"></i>
          {isSubmitting ? `${props.submitText}...` : props.submitText}
        </button>
      </div>
    </div>
  );
}
